import { Resource } from "rt-sd-common";
import { assignArrayStr, assignProps, funStrCheck } from "rt-sd-common";
import { sgiLogger } from "rt-sd-common";
import { ObjFactory } from "rt-sd-common";
import { SgiEventHandler } from "../SgiEventHandler";
import { sgiFormCtlCheck } from "../sgiFormCtlValidator";
import SgiCtlComponent from "./SgiCtlComponent";
import { getFunctionByKey, testReactVsn } from "./SgiCommon";

export default class SgiFormCtlComponent extends SgiCtlComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,//由super构造器产生
            //初始化state
            validRules: {},
            validState: true,
            required: false,
            loading: false,
            isLabel: false,
            formItemProps: {
                style: { 'margin-bottom': "1px", 'margin-top': "1px" },
                hasFeedback: false,
                help: undefined,
                validateStatus: 'success',
                // colon: false //不显示：
            }, //存放formItem属性
            inputProps: {
                style: { width: "100%" },
                // value: undefined,  //文本框显示值 //2018.04.27-yly,有value会导致默认值无法赋值
                disabled: false, //是否可用
            },//存放input属性
            _formProps: {}, //存放form属性
            formItemClass: []
        };
    }

    _maker() {
        super._maker();

        let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        let { formItemProps, inputProps, _props, _class, _style, formItemClass } = this.state;

        if (!moduleDesc) return;

        // 属性和类名合并
        delete _style.margin;
        assignProps(formItemProps, _props);
        assignArrayStr(formItemClass, _class);

        /**************** 转换公共属性 ****************/
        // label样式回显
        const isLabel = moduleDesc.isLabel;
        this.state.isLabel = !!isLabel;
        if (isLabel) formItemProps.colon = true;// 显示冒号

        var isDis = moduleDesc.isDis; //是否可用
        inputProps.disabled = isDis;

        var isRead = moduleDesc.isRead; //是否只读
        // inputProps.style.readonly = 'expression(this.readonly = true)';
        inputProps.readOnly = !!isRead;

        if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
            var text = Resource.getTRByPrm(moduleDesc).te; //设置标签
            if (text) formItemProps.label = text;
        }

        var ctlW = moduleDesc.ctlW; //控件宽度
        var ctlH = moduleDesc.ctlH; //控件高度
        if (ctlH) {
            formItemProps.style.height = ctlH;
            inputProps.style.height = ctlH;//输入框也随着高度变动
        } else {
            formItemProps.style.height = undefined;//编辑的时候即时刷新，也可以不加
            inputProps.style.height = undefined;//编辑的时候即时刷新，也可以不加
        }

        delete formItemProps.style.width;//由sgiComponent创建，影响比例布局

        var lblW = moduleDesc.lblW; //设置标签宽度

        if (ctlW && lblW) {
            var lblWSpan = parseInt(lblW / ctlW * 24)
            var wrapperSpan = 24 - lblWSpan;
            formItemProps.labelCol = { span: lblWSpan }
            formItemProps.wrapperCol = { span: wrapperSpan }
        } else {
            formItemProps.labelCol = { span: 6 }
            formItemProps.wrapperCol = { span: 18 }
        }

        var isLbl = moduleDesc.isLbl; //设置是否隐藏标签
        if (isLbl) {
            formItemProps.label = undefined;
            formItemProps.labelCol = { span: 0 }
            formItemProps.wrapperCol = { span: 24 }
        }

        var inpPopTe = moduleDesc.inpPopTe; //提示内容
        if (inpPopTe) inputProps.placeholder = inpPopTe;

        var defVal10 = moduleDesc.defVal10; //默认内容
        if (defVal10 !== undefined) inputProps.defaultValue = defVal10;//数字控件是可以有0的，所以别用!判定

        var bdText = moduleDesc.bdText; //后置内容
        if (bdText) inputProps.addonAfter = bdText;

        var alwBlk = moduleDesc.alwBlk; //是否允许为空
        formItemProps.required = !alwBlk;
        this.state.validRules.required = !alwBlk;
        this.state.required = !alwBlk;
        if (isLabel) {//仅回显状态不校验
            formItemProps.required = false;
            this.state.validRules.required = false;
            this.state.required = false;
        }
        // if (!alwBlk) {
        //     formItemProps.required = !alwBlk;
        //     this.state.validRules.required = !alwBlk;
        // } else {
        //     formItemProps.required = !alwBlk;
        //     this.state.validRules.required = !alwBlk;
        // }

        if (moduleDesc.vldC) this.state.validRules.dataType = moduleDesc.vldC;

        var maxL = moduleDesc.maxL; //设置字段输入的最大长度
        if (maxL) this.state.validRules.maxL = maxL;
        else this.state.validRules.maxL = undefined;
        var minL = moduleDesc.minL; //设置字段输入的最小长度
        if (minL) this.state.validRules.minL = minL;
        else this.state.validRules.minL = undefined;

        let vldC = moduleDesc.vldC;
        if (vldC && (vldC === "int" || vldC === "double" || vldC === "money" || vldC === "number")) {
            var maxV = moduleDesc.maxV; //设置字段输入的最大值
            if (maxV) this.state.validRules.maxV = maxV;
            else this.state.validRules.maxV = undefined;
            var minV = moduleDesc.minV; //设置字段输入的最小值
            if (minV) this.state.validRules.minV = minV;
            else this.state.validRules.minV = undefined;
        }

        var isHdn = moduleDesc.isHdn; //是否隐藏
        if (isHdn) {
            formItemProps.style.display = "none"
        } else {
            formItemProps.style.display = undefined;
        }

        inputProps.nowrap = !!moduleDesc.nowrap;

        // form属性
        this.state._formProps = moduleDesc._formProps || {};

        var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
        var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
        var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现

        // var prefix = moduleDesc.prefix;//前缀图
        // if (prefix) inputProps.prefix = prefix;

        this.state.showCheck = moduleDesc.showCheck;

        // 自定义校验规则
        let cstmValid = moduleDesc.cstmValid;
        let $cstmValid;
        if (cstmValid) {
            try {
                $cstmValid = new Function("module", "objFct", "value", cstmValid);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            this.state.validRules.cstmValid = $cstmValid;
        }

        /**************** 控件自身属性 ****************/
        this.__AddInputAttribute();
        /**************** 设置布局 ****************/
        // setFormCtlLayout(moduleDesc, formItemProps, inputProps);
        /**************** 绑定值 ****************/
        this.__bindValue();
        /**************** 绑定事件 ****************/
        this.__bindEvent();
    }

    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
    _renderBeforeReturn() {
        const { parentModule, moduleDesc, objFct, type } = this.props;
        let { formItemProps, inputProps, required } = this.state;
        let { functions } = this.data;

        // 自定义样式处理
        // const getCstmStyle = functions.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                tool.sgiLogger.log(error);
            }
        }
        for (const key in cstmStyle) {
            if (key.toLowerCase() === "formItemStyle".toLowerCase() || key.toLowerCase() === "formItemProps".toLowerCase()) {
                Object.assign(formItemProps.style, cstmStyle[key] || {});//formTtem样式
            } else if (key.toLowerCase() === "inputStyle".toLowerCase() || key.toLowerCase() === "inputProps".toLowerCase()) {
                Object.assign(inputProps.style, cstmStyle[key] || {});//input样式
            } else {
                this.state[key] = cstmStyle[key];//其他样式，富文本等的其他样式
            }
        }

        // 必填属性处理
        formItemProps.required = required;
        this.state.validRules.required = required;
    }

    // 控件实现
    __AddInputAttribute(moduleDesc, formItemProps, inputProps) { }

    __bindValue() {

        let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        let { formItemProps, inputProps, _props, _class, formItemClass } = this.state;

        if (!moduleDesc.c) return;

        //this.bdInst = bdInst;
        var attname = moduleDesc.c;
        this.state.attname = attname;

        if (!bdInst || !objFct) return;

        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        var bdInstValue;
        if (this.props.type === 'tb') {
            const bdInstKeyList = bdInst.split('`');
            const bdInstList = objFct.get(bdInstKeyList[0]);
            if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
            }
        } else {
            bdInstValue = objFct.get(bdInst);
        }

        // 带点./[/]解析
        let evalFlg = RegExp(/[.|\[|\]]+/).test(attname);
        let valueFlg = evalFlg && eval(`(bdInstValue.${attname})`) !== undefined;

        if (bdInstValue && (bdInstValue[attname] !== undefined || valueFlg)) {//2018.04.27-yly,有value会导致默认值无法赋值
            //给checkbox 使用
            // if (checked) {
            let value;
            if (evalFlg) {
                // 带层级解析，catch防止中断
                try {
                    value = eval(`(bdInstValue.${attname})`);
                } catch (error) {
                    sgiLogger.error(`属性名解析出错，当前属性名${attname}`);
                    sgiLogger.eventErr(error);
                }
            } else value = bdInstValue[attname];
            if (this.props._name === "SgiFormCheckbox") {
                inputProps.checked = value ? true : false;
            } else {
                inputProps.value = value;
            }
        } else {//20180704 wzhe 默认值 给当前value
            inputProps.value = inputProps.defaultValue;
            if (bdInstValue) {
                if (evalFlg) {
                    // 带层级解析，catch防止中断
                    try {
                        eval(`(bdInstValue.${attname} = inputProps.defaultValue)`);
                    } catch (error) {
                        sgiLogger.error(`属性名解析出错，当前属性名${attname}`);
                        sgiLogger.eventErr(error);
                    }
                } else bdInstValue[attname] = inputProps.defaultValue;
            }
        }
    }

    __bindEvent() {

        let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        let { formItemProps, inputProps, _props, _class, formItemClass } = this.state;
        let { functions } = this.data;

        //拖拽模式 不生成事件
        if (type == 'dnd') return;

        //onchange
        var chgLsn = moduleDesc.chgLsn; // 用户自定义点击事件
        if (chgLsn) {
            var $chgLsn;
            try {
                $chgLsn = new Function("module", "objFct", 'nv', 'record', 'extra', chgLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onChange = $chgLsn;
        }
        inputProps.onChange = SgiEventHandler.onChange.bind(this, this);

        //onFocus
        var inLsn = moduleDesc.inLsn; // 用户自定义点击事件
        if (inLsn) {
            var $inLsn;
            try {
                $inLsn = new Function("module", "objFct", inLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onFocus = $inLsn;
            inputProps.onFocus = SgiEventHandler.onFocus.bind(this, this);
        }

        //onBlur
        var lveLsn = moduleDesc.lveLsn; // 用户自定义点击事件
        if (lveLsn) {

            var $lveLsn;
            try {
                $lveLsn = new Function("module", "objFct", lveLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onBlur = $lveLsn;
            inputProps.onBlur = SgiEventHandler.onBlur.bind(this, this);
        }

        // 自定义渲染组件
        const cstmRender = moduleDesc.cstmRender;
        if (funStrCheck(cstmRender)) {
            let $cstmRender;
            try {
                $cstmRender = new Function("module", "inputProps", "value", "objFct", cstmRender);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.cstmRender = $cstmRender;
        }

        // //onInput
        // inputProps.onInput = function() {
        //     message.info('获取焦点事件');
        // }
        // //点击事件
        // inputProps.onClick = function () {
        //     message.info('点击事件');
        // }
        // //双击事件
        // inputProps.onDoubleClick = function () {
        //     message.info('双击事件');
        // }
        // //onCopy
        // inputProps.onCopy = function () {
        //     message.info('复制事件');
        // }
        // //onCut
        // inputProps.onCut = function () {
        //     message.info('剪切事件');
        // }
        // //onPaste
        // inputProps.onPaste = function () {
        //     message.info('粘贴事件');
        // }
    }

	/**
	* 设置value值
	* 刷新控件时候，调用的方法
	*/
    setValue(value) {
        if (value === this.state.inputProps.value) return;

        this.state.inputProps.value = value;

        // 页面校验 刷新不校验
        // this.validate(value);
        this.setState({});
    }

	/**
	* 获取value值
	*/
    getValue() {
        return this.state.inputProps.value;
    }

	/**
	 * 设置是否禁用
	 */
    setDisabled(value) {
        this.state.inputProps.disabled = value;
        this.setState(this.state.inputProps);
    }

	/**
	 * 设置form禁用标识
	 * @param {boolean} formDisabled form禁用标识
	 */
    setFormDisabled(formDisabled) {
        this.state.inputProps.formDisabled = formDisabled;
        this.setState(this.state.inputProps);
    }

	/**
	* 设置是否隐藏
	*/
    setHidden(value) {
        this.state.formItemProps.style.display = value ? "none" : undefined;
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            this.state.formItemProps.style = { ...this.state.formItemProps.style };
        }
        this.setState(this.state.formItemProps);
    }

	/**
	 * 设置是否必填
	 * @param {boolean} required 是否必填
	 */
    setRequired(required) {
        this.setState({ required: !!required });
    }
	/**
	* 设置是否只读
	*/
    setReadonly(value) {
        this.state.inputProps.readonly = value;
        this.setState(this.state.inputProps);
    }
	/**
	 * 页面修改时，刷新工厂绑定的值
	 */
    ctlRefresh(attname, bdInst, objFct, value) {

        //对象工厂的值刷新
        this.setBindValue(attname, bdInst, objFct, value);

        //更新state
        this.state.inputProps.value = value;

        //页面校验
        this.validate(value);
    }

	/**
	 * 仅更新工厂绑定值
	 * @param {string} attname 属性名
	 * @param {string} bdInst 绑定实例名
	 * @param {ObjFactory} objFct 对象工厂
	 * @param {object} value 值
	 */
    setBindValue(attname, bdInst, objFct, value) {
        if (bdInst && attname) {
            let bdInstData;
            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
            if (typeof bdInst === "string") {
                //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
                //通过type区分，type==tb时候为表格控件，其他时候为普通控件
                if (this.props.type === 'tb') {
                    const bdInstKeyList = bdInst.split('`');
                    const bdInstList = objFct.get(bdInstKeyList[0]);
                    if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                        bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
                    }
                } else {
                    bdInstData = objFct.get(bdInst);
                }
            } else {
                bdInstData = bdInst;
            }

            if (bdInstData) {
                if (RegExp(/[.|\[|\]]+/).test(attname)) {
                    // 带层级赋值，catch避免中断
                    try {
                        eval(`(bdInstData.${attname} = value)`);
                    } catch (error) {
                        sgiLogger.error(`修改绑定对象时，属性名解析出错，当前属性名[${attname}]`);
                        sgiLogger.eventErr(error);
                    }
                } else {
                    bdInstData[attname] = value;
                }
            }
        }
    }

    // 检查数据合法性
    validate(value) {
        if (!value) {
            value = this.state.inputProps.value;
        }
        if (this.state.formItemProps.style.display == "none") {
            this.setSuccess();
            return false;
        }
        var validRules = this.state.validRules;
        if (validRules.length === 0) {
            this.setSuccess();
            return false;
        }

        //var flag = true;
        var msg = sgiFormCtlCheck(validRules, value, { module: this, objFct: this.props.objFct });
        if (Object.prototype.toString.call(msg) === "[object Object]") {
            this.setValidate(msg.help, msg.validateStatus, msg.hasFeedback);
        } else if (msg) {
            this.setError(msg);
        } else {
            this.setSuccess();
        }
        return msg;
    }
    setError(msg) {
        this.state.formItemProps.hasFeedback = true;
        this.state.formItemProps.help = msg;
        this.state.formItemProps.validateStatus = 'error';
        this.setState(this.state.formItemProps);
    }
    setSuccess() {
        this.state.formItemProps.hasFeedback = false;
        this.state.formItemProps.help = undefined;
        this.state.formItemProps.validateStatus = 'success';
        this.setState(this.state.formItemProps);
    }
    // 设置组件校验(对外接口)
    setValidate(message, status, hasFeedback) {
        this.state.formItemProps.help = message;
        this.state.formItemProps.validateStatus = status;
        this.state.formItemProps.hasFeedback = !!hasFeedback;
        this.setState({});
    }
    refresh() {
        this.loaded = false;
        this.setState({ loading: false });
    }
    getIsLabel() {
        // isLabel
        const isLabel = this.state.isLabel || this.state.formIsLabel;

        // 标签和非标签特殊处理
        let { formItemProps, validRules } = this.state;
        let { moduleDesc = {} } = this.props;
        if (isLabel) {
            formItemProps.required = false;
            validRules.required = false;
        } else {
            let alwBlk = moduleDesc.alwBlk; //是否允许为空
            formItemProps.required = !alwBlk;
            validRules.required = !alwBlk;
        }

        // 返回
        return isLabel;
    }
    getReviseProps() {
        const { inputProps, formItemProps, _formProps } = this.state;
        let isLabel = this.getIsLabel();
        let reviseProps = {
            _inputProps: {
                isLabel,
                disabled: inputProps.disabled || inputProps.formDisabled,
                title: inputProps.value,
                className: inputProps.nowrap ? "sgiFormItemSpan" : undefined,
            },
            _formItemProps: {
                colon: isLabel || _formProps.colon, //冒号
            }
        };
        return reviseProps;
    }


}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiFormCtlComponent.js